import axios from 'axios'
import { env } from '../environments/environment'
import store from '../redux/store'
import { notifierActions } from '../redux/slices/notifier/notifier'
import { GENERAL_LOGIN_PATH } from '../config/pathList'

const httpClient = axios.create({
    baseURL: env.REACT_APP_API_URL,
    withCredentials: true,
})

export const sendHttpErrorNotification = (dispatch, error) =>
    dispatch(
        notifierActions.enqueueSnackbar({
            message: (error.response && error.response.data.message) || 'api.error',
            options: {
                variant: 'error',
            },
        }),
    )

httpClient.interceptors.response.use(
    (res) => res,
    (error) => {
        if (
            error &&
            error.response &&
            error.response.status === 401 &&
            error.response.config &&
            error.response.config.url !== GENERAL_LOGIN_PATH.substring(1)
        ) {
            sessionStorage.clear()
            window.location.href = GENERAL_LOGIN_PATH
        } else if (!axios.isCancel(error)) {
            sendHttpErrorNotification(store.dispatch, error)
        }
        throw error
    },
)

export default httpClient
